import { Component, OnInit } from "@angular/core";
import { PrintService } from "../print.service";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-print-questionnaire",
    templateUrl: "./print-questionnaire.component.html",
    styleUrls: ["./print-questionnaire.component.scss"],
    standalone: false
})
export class PrintQuestionnaireComponent implements OnInit {
  now: Date;
  code;
  logoUrl: string;

  constructor(public print: PrintService, private route: ActivatedRoute, public translate: TranslateService) {
    this.now = new Date();
  }

  ngOnInit(): void {
    this.code = this.route.snapshot.params.code;
    this.logoUrl = '/api/questionnaires/logo/' + this.code;
    this.print.loadQuestionnaireAnswers(this.code);
  }
}
